export const HELP_CENTER_URL = 'https://helpdesk.jemhr.online';
